export default "__VITE_ASSET__9790e9e5__"